import {
  CLIMATE_PLANS_ADMIN_ROLES,
  CLIMATE_PLANS_MEMBER_ROLES,
} from '../constants/membershipAccess';
import { useUserRole } from '../contexts/UserRoleContext';

export function useClimatePlansMember(): { isMember: boolean; loading: boolean } {
  const { hasAnyRole, loading } = useUserRole();
  return {
    loading,
    isMember: hasAnyRole(CLIMATE_PLANS_MEMBER_ROLES),
  };
}

export function useClimatePlansAdmin(): { isAdmin: boolean; loading: boolean } {
  const { hasAnyRole, loading } = useUserRole();
  return {
    loading,
    isAdmin: hasAnyRole(CLIMATE_PLANS_ADMIN_ROLES),
  };
}
